import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { Link } from "@/modules/theme/components/Link/Link";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

import { ReactComponent as PlayIcon } from "../icons/play-icon.svg";

const translationNamespace = "pages/SubtaskDetailsPage";

type TutorialLinkProps = {
  to: string;
};

export const TutorialLink: React.FC<TutorialLinkProps> = ({ to }) => {
  const { t } = useTranslation(translationNamespace);
  const classes = createTutorialLinkStyles(useTheme());
  return (
    <Link.Internal to={to} className={classes.root}>
      <PlayIcon />
      <span>{t("Watch tutorial")}</span>
    </Link.Internal>
  );
};

function createTutorialLinkStyles({ spacing, typography }: Theme) {
  return {
    root: css({
      display: "grid",
      gridAutoFlow: "column",
      gap: spacing(1),
      marginBottom: spacing(2),
      justifyContent: "start",
      alignItems: "center",
      textDecoration: "none",
      wordBreak: "break-all",
      fontWeight: typography.fontWeight.semiBold,
    }),
  };
}
